import React from 'react'
import { TableColumn } from '../../../components/_EOS/GenericTable/types'
import { TypePosition } from '../../../components/TypePosition/types/TypePosition'
import { YesNoBadge } from '../../../components/YesNoBadge'


export const getColumnsConfig = (): TableColumn<TypePosition>[] => [
  {
    key: 'typePositionId',
    title: 'ID'
  },
  {
    key: 'typePositionCode',
    title: 'Código'
  },
  {
    key: 'typePositionDescription',
    title: 'Descripción'
  },
  {
    key: 'considerInventory',
    title: 'Incluido Para Publicar Stock',    
    render: (value: unknown) => <YesNoBadge value={value as boolean} />
  },
  {
    key: 'requireZone',
    title: 'Requiere Zona',
    render: (value: unknown) => <YesNoBadge value={value as boolean} />
  }
]
